<script setup lang="ts">
const props = defineProps<{
  block: BlockHeading,
  noHorizontalPadding?: boolean,
}>()
</script>

<template>
  <section class="container-d my-3" :class="{ 'px-1': !noHorizontalPadding }">
    <h1
      :is="block?.level || 'h1'"
      class="text-md"
    >
      {{ block.heading }}
    </h1>

    <h2
      v-if="block.subHeading"
      class="text-d"
    >
      {{ block.subHeading }}
    </h2>
  </section>
</template>
